var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:[_vm.mode],on:{"click":_vm.onClick}},[(_vm.hasIcon)?_c('AssetV3',{staticClass:"icon",attrs:{"dir":"icons","name":_vm.iconName}}):_vm._e(),_c('p',{staticClass:"button-text white"},[_vm._v(_vm._s(_vm.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }